import { fireSelectItemGAEvent } from '@global/gtm/base';
import ShopClick from '@global/gtm/class/clickClass';

/**
 * Generate a GTM event when a shop list item is clicked.
 *
 * @param {object} itemPayload - The payload containing information about the clicked item.
 *   @param {string} itemPayload.customMarketID - 客製化賣場 ID
 *   @param {string} itemPayload.size - 點擊商品的尺寸 (options)
 */
export default function fireShopListClickGTMEvent(itemPayload) {
  const category = new ShopClick(itemPayload);
  const ga4Parameters = category.getGAItemInfo();

  fireSelectItemGAEvent(ga4Parameters);
}
